import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { RoutePath } from '../../routes';
import styles from './navbar.scss';

type Props = {
  id: string;
};

const Navbar: React.FC<Props> = (props) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const onClickHamburger = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  const onWindowScroll = () => {
    setIsScrolled(window.scrollY > 100);
  };
  window.addEventListener('scroll', onWindowScroll);

  const renderHamburger = () => {
    return isMenuOpened ? <FontAwesomeIcon icon={faXmark} fixedWidth /> : <FontAwesomeIcon icon={faBars} fixedWidth />;
  };

  return (
    <div id={props.id} data-testid={props.id} className={classNames(styles['navbar'], isScrolled ? styles['navbar_scrolled'] : null)}>
      <Link to="/">
        <h1>r2v2.co.uk</h1>
      </Link>

      {/* <ul className={classNames(styles['menu'], isMenuOpened ? styles['menu_opened'] : null)}>
        <li>
          <Link to={RoutePath.Home}>Home</Link>
        </li>
        <li>
          <Link to={RoutePath.Projects}>Projects</Link>
        </li>
        <li>
          <Link to={RoutePath.About}>About</Link>
        </li>
        <li>
          <Link to={RoutePath.Contact}>Contact</Link>
        </li>
      </ul> */}

      <div className={styles['hamburger']} onClick={onClickHamburger}>
        {renderHamburger()}
      </div>
    </div>
  );
};

export default Navbar;
